import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Zap, ArrowRight } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';

export const HotOfferBanner = () => {
  const { t } = useTranslation();

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-9 flex items-center justify-center px-4 overflow-hidden"
      style={{ background: 'linear-gradient(90deg, #c96a0a 0%, #e0821a 35%, #fbaf3a 65%, #e0821a 100%)' }}
      data-testid="promo-banner"
    >
      {/* Shimmer */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.08) 50%, transparent 100%)' }}
        animate={{ x: ['-100%', '100%'] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'linear', repeatDelay: 2 }}
      />

      <div className="flex items-center gap-2 text-sm font-semibold text-[#1a0a00] relative">
        <Zap className="w-3.5 h-3.5 fill-[#1a0a00] shrink-0" />
        <span className="hidden xs:inline">{t('banner.label')}&nbsp;</span>
        <span>{t('banner.text')}</span>
        <Link
          to="/vps/kvm-ryzen"
          className="flex items-center gap-1 ml-1 px-2.5 py-0.5 bg-[#1a0a00]/80 text-[#fbaf3a] rounded text-xs font-bold hover:bg-[#1a0a00] transition-colors whitespace-nowrap"
          data-testid="promo-banner-cta"
        >
          {t('banner.cta')}
          <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
};

export default HotOfferBanner;
